import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, normalizeStyle as _normalizeStyle, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40c74184"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ms-header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ms-header-icon" }, "💬", -1))
const _hoisted_3 = { style: {"flex":"1","display":"flex","align-items":"center","justify-content":"space-between"} }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ms-title" }, "Messages & Alertes", -1))
const _hoisted_5 = ["title"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "ms-subtitle-ext"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"rgb(246 174 18)","font-weight":"bold","font-size":"2em"} }, "+", -1))
const _hoisted_9 = { class: "ms-tabs" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "ms-read-filter" }
const _hoisted_13 = ["data-testid", "onClick"]
const _hoisted_14 = {
  key: 0,
  class: "rf-badge"
}
const _hoisted_15 = { class: "rf-tools" }
const _hoisted_16 = {
  class: "rf-sort-select-wrap",
  title: "Critère de tri"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons rf-sort-icon" }, "sort", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "date" }, "Date", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "priority" }, "Priorité", -1))
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = ["title"]
const _hoisted_22 = { class: "material-icons" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "delete_sweep", -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { class: "ms-search" }
const _hoisted_27 = { class: "ms-list" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "mc-head" }
const _hoisted_30 = { class: "mc-info" }
const _hoisted_31 = { class: "mc-subject" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "mc-meta" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { class: "mc-actions" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = { class: "mc-time" }
const _hoisted_40 = {
  key: 0,
  class: "mc-excerpt"
}
const _hoisted_41 = {
  key: 1,
  class: "mc-deleted-note",
  "data-testid": "omp-deleted-note"
}
const _hoisted_42 = {
  key: 2,
  class: "mc-kpi-strip",
  "data-testid": "omp-message-kpis"
}
const _hoisted_43 = ["title"]
const _hoisted_44 = { class: "mc-kpi-pill-lbl" }
const _hoisted_45 = { class: "mc-kpi-pill-val" }
const _hoisted_46 = { class: "mc-footer" }
const _hoisted_47 = {
  key: 0,
  class: "tag tg-deleted"
}
const _hoisted_48 = {
  key: 4,
  style: {"margin-left":"auto","font-size":"11px","color":"var(--eflo-text-3)"}
}
const _hoisted_49 = {
  key: 1,
  class: "ms-empty"
}
const _hoisted_50 = { class: "dd-header" }
const _hoisted_51 = { class: "dd-icon" }
const _hoisted_52 = { class: "dd-header-info" }
const _hoisted_53 = { class: "dd-subject" }
const _hoisted_54 = { class: "dd-header-meta" }
const _hoisted_55 = {
  class: "dd-thread",
  ref: "threadRef"
}
const _hoisted_56 = {
  key: 0,
  class: "dd-thread-loading"
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dd-loading-spinner" }, null, -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Chargement de la conversation...", -1))
const _hoisted_59 = [
  _hoisted_57,
  _hoisted_58
]
const _hoisted_60 = {
  key: 0,
  class: "dd-date-sep"
}
const _hoisted_61 = { class: "dd-bubble-wrap" }
const _hoisted_62 = {
  key: 0,
  class: "dd-bubble-meta-top"
}
const _hoisted_63 = { class: "dd-sender-name" }
const _hoisted_64 = {
  key: 0,
  class: "dd-event-badge ev-reply"
}
const _hoisted_65 = {
  key: 1,
  class: "dd-event-badge ev-transfer"
}
const _hoisted_66 = {
  key: 1,
  class: "dd-bubble-meta-top align-right"
}
const _hoisted_67 = {
  key: 0,
  class: "dd-event-badge ev-reply"
}
const _hoisted_68 = {
  key: 1,
  class: "dd-event-badge ev-transfer"
}
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dd-sender-name" }, "Vous", -1))
const _hoisted_70 = {
  key: 2,
  class: "dd-bubble-ref"
}
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dd-bubble-ref-bar" }, null, -1))
const _hoisted_72 = { class: "dd-bubble-ref-label" }
const _hoisted_73 = { class: "dd-bubble-ref-text" }
const _hoisted_74 = { class: "dd-bubble-body" }
const _hoisted_75 = {
  key: 0,
  class: "dd-bubble-attachments"
}
const _hoisted_76 = {
  key: 2,
  class: "dd-thread-empty"
}
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dd-thread-empty-icon" }, "💬", -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Aucun historique disponible", -1))
const _hoisted_79 = [
  _hoisted_77,
  _hoisted_78
]
const _hoisted_80 = { class: "dd-actions-bar" }
const _hoisted_81 = {
  key: 0,
  class: "dd-actions-row"
}
const _hoisted_82 = {
  key: 1,
  class: "dd-actions-row"
}
const _hoisted_83 = ["disabled"]
const _hoisted_84 = ["disabled"]
const _hoisted_85 = {
  key: 0,
  class: "eflo-email-modal",
  "data-testid": "omp-email-modal"
}
const _hoisted_86 = { class: "em-header" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "em-icon" }, "📧", -1))
const _hoisted_88 = { class: "em-header-info" }
const _hoisted_89 = { class: "em-subject" }
const _hoisted_90 = {
  key: 0,
  class: "em-ref"
}
const _hoisted_91 = { class: "em-fields" }
const _hoisted_92 = { class: "em-field" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "em-lbl" }, "De", -1))
const _hoisted_94 = { class: "em-val" }
const _hoisted_95 = { class: "em-field" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "em-lbl" }, "À", -1))
const _hoisted_97 = { class: "em-val" }
const _hoisted_98 = {
  key: 0,
  class: "em-field"
}
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "em-lbl" }, "Cc", -1))
const _hoisted_100 = { class: "em-val" }
const _hoisted_101 = { class: "em-field" }
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "em-lbl" }, "Date", -1))
const _hoisted_103 = { class: "em-val" }
const _hoisted_104 = { class: "em-body" }
const _hoisted_105 = ["srcdoc"]
const _hoisted_106 = {
  key: 1,
  class: "em-plain"
}
const _hoisted_107 = { class: "eflo-compose" }
const _hoisted_108 = { class: "cm-header" }
const _hoisted_109 = { class: "cm-title" }
const _hoisted_110 = { class: "cm-body" }
const _hoisted_111 = { class: "cm-col cm-col-left" }
const _hoisted_112 = { class: "form-sec" }
const _hoisted_113 = { class: "form-sec-title" }
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "fst-dot",
  style: {"background":"var(--eflo-blue)"}
}, null, -1))
const _hoisted_115 = { class: "form-sec-body" }
const _hoisted_116 = { class: "form-row" }
const _hoisted_117 = { class: "form-g" }
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-lbl" }, [
  /*#__PURE__*/_createTextVNode("Type de message "),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "★")
], -1))
const _hoisted_119 = { class: "type-toggle" }
const _hoisted_120 = ["onClick"]
const _hoisted_121 = {
  key: 0,
  class: "form-g"
}
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-lbl" }, [
  /*#__PURE__*/_createTextVNode(" Motif d'alerte "),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "★")
], -1))
const _hoisted_123 = { class: "fselect-wrap" }
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Choisir un motif...", -1))
const _hoisted_125 = ["value"]
const _hoisted_126 = {
  key: 1,
  class: "form-g"
}
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-lbl" }, [
  /*#__PURE__*/_createTextVNode("Sujet "),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "★")
], -1))
const _hoisted_128 = { class: "fselect-wrap" }
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Choisir un sujet...", -1))
const _hoisted_130 = ["value"]
const _hoisted_131 = {
  key: 2,
  class: "form-g"
}
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-lbl" }, "Référence(s)", -1))
const _hoisted_133 = { class: "ref-search-wrap" }
const _hoisted_134 = {
  key: 0,
  class: "ref-dropdown"
}
const _hoisted_135 = {
  key: 0,
  class: "ref-opt ref-loading"
}
const _hoisted_136 = ["onMousedown"]
const _hoisted_137 = { class: "ref-id" }
const _hoisted_138 = {
  key: 1,
  class: "ref-dropdown"
}
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ref-opt ref-empty" }, "Aucun résultat", -1))
const _hoisted_140 = [
  _hoisted_139
]
const _hoisted_141 = {
  key: 0,
  class: "ref-chips"
}
const _hoisted_142 = ["onClick"]
const _hoisted_143 = {
  key: 0,
  class: "form-sec"
}
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-sec-title" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "fst-dot",
    style: {"background":"var(--eflo-teal)"}
  }),
  /*#__PURE__*/_createTextVNode(" Destinataires ")
], -1))
const _hoisted_145 = { class: "form-sec-body" }
const _hoisted_146 = { class: "form-g" }
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-lbl" }, [
  /*#__PURE__*/_createTextVNode("Destinataires "),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "★")
], -1))
const _hoisted_148 = {
  key: 0,
  class: "recip-intervenants-strip"
}
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "recip-intervenants-strip-title" }, "Intervenants sur la commande", -1))
const _hoisted_150 = { class: "recip-intervenant-card-info" }
const _hoisted_151 = { class: "recip-badge recip-badge-order-party" }
const _hoisted_152 = { class: "recip-meta" }
const _hoisted_153 = { class: "recip-name" }
const _hoisted_154 = {
  key: 0,
  class: "recip-sub"
}
const _hoisted_155 = { class: "recip-intervenant-card-cta" }
const _hoisted_156 = ["onClick"]
const _hoisted_157 = ["onClick"]
const _hoisted_158 = {
  key: 1,
  class: "recip-filter-tabs"
}
const _hoisted_159 = { class: "recip-search-wrap" }
const _hoisted_160 = ["placeholder"]
const _hoisted_161 = {
  key: 0,
  class: "recip-dropdown"
}
const _hoisted_162 = ["onMousedown"]
const _hoisted_163 = { class: "recip-meta" }
const _hoisted_164 = { class: "recip-name" }
const _hoisted_165 = {
  key: 0,
  class: "recip-sub"
}
const _hoisted_166 = {
  key: 1,
  class: "recip-sub"
}
const _hoisted_167 = {
  key: 1,
  class: "recip-dropdown"
}
const _hoisted_168 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "recip-opt recip-empty" }, "Aucun résultat", -1))
const _hoisted_169 = [
  _hoisted_168
]
const _hoisted_170 = {
  key: 2,
  class: "recip-chips"
}
const _hoisted_171 = { class: "recip-meta" }
const _hoisted_172 = {
  key: 0,
  class: "recip-sub"
}
const _hoisted_173 = {
  key: 1,
  class: "recip-sub"
}
const _hoisted_174 = ["onClick"]
const _hoisted_175 = {
  key: 3,
  class: "recip-empty-msg"
}
const _hoisted_176 = { class: "cm-col cm-col-right" }
const _hoisted_177 = { class: "form-sec" }
const _hoisted_178 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-sec-title" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "fst-dot",
    style: {"background":"var(--eflo-purple)"}
  }),
  /*#__PURE__*/_createTextVNode(" Contenu ")
], -1))
const _hoisted_179 = { class: "form-sec-body" }
const _hoisted_180 = {
  key: 0,
  class: "compose-context-banner"
}
const _hoisted_181 = { key: 0 }
const _hoisted_182 = { key: 1 }
const _hoisted_183 = { class: "form-g" }
const _hoisted_184 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-lbl" }, [
  /*#__PURE__*/_createTextVNode("Message "),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "★")
], -1))
const _hoisted_185 = {
  key: 0,
  class: "form-sec"
}
const _hoisted_186 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-sec-title" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "fst-dot",
    style: {"background":"var(--eflo-orange)"}
  }),
  /*#__PURE__*/_createTextVNode(" Documents joints ")
], -1))
const _hoisted_187 = { class: "form-sec-body" }
const _hoisted_188 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "file-hint" }, " Types acceptes: PDF,JPG, JPEG, PNG - Taille max: 10 Mo. ", -1))
const _hoisted_189 = {
  key: 0,
  class: "form-g"
}
const _hoisted_190 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-lbl" }, "Depuis le dossier", -1))
const _hoisted_191 = { class: "doc-search-wrap" }
const _hoisted_192 = { class: "doc-items-scroll" }
const _hoisted_193 = ["onClick"]
const _hoisted_194 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "📄", -1))
const _hoisted_195 = { class: "doc-item-info" }
const _hoisted_196 = { class: "doc-name" }
const _hoisted_197 = { class: "doc-process" }
const _hoisted_198 = { class: "doc-chk" }
const _hoisted_199 = {
  key: 1,
  class: "doc-empty"
}
const _hoisted_200 = {
  key: 0,
  class: "ref-chips"
}
const _hoisted_201 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "📎", -1))
const _hoisted_202 = ["onClick"]
const _hoisted_203 = { class: "form-g" }
const _hoisted_204 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-lbl" }, "Joindre un fichier", -1))
const _hoisted_205 = {
  key: 0,
  class: "mt-2",
  style: {"font-size":"12px","color":"var(--eflo-text-2)"}
}
const _hoisted_206 = {
  key: 0,
  class: "cm-sending"
}
const _hoisted_207 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cm-sending-inner" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "cm-spinner" }),
  /*#__PURE__*/_createElementVNode("span", null, "Envoi en cours...")
], -1))
const _hoisted_208 = [
  _hoisted_207
]
const _hoisted_209 = { class: "cm-footer" }
const _hoisted_210 = { class: "cm-footer-left" }
const _hoisted_211 = {
  key: 0,
  class: "cm-error"
}
const _hoisted_212 = { class: "cm-footer-right" }
const _hoisted_213 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.inline)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["eflo-sidebar-overlay", { open: _ctx.isOpen }]),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        }, null, 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["eflo-msg-sidebar", { open: _ctx.isOpen, 'is-inline': _ctx.inline }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _hoisted_4,
            (_ctx.orderExternalReference || _ctx.orderReference || _ctx.orderLabel)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["ms-subtitle", { 'ms-subtitle-link': _ctx.orderId }]),
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.openOrderTab()), ["stop"])),
                  title: _ctx.orderId ? 'Ouvrir le dossier dans un nouvel onglet' : ''
                }, [
                  _createTextVNode(_toDisplayString(_ctx.orderExternalReference || _ctx.orderReference) + " ", 1),
                  (_ctx.orderLabel)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, " · " + _toDisplayString(_ctx.orderLabel), 1))
                    : _createCommentVNode("", true),
                  (_ctx.orderId)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, "↗"))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_5))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("button", {
            class: "ms-new-btn",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openCompose()))
          }, [
            _hoisted_8,
            _createTextVNode(" Nouveau message / alerte")
          ])
        ]),
        (!_ctx.inline)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "ms-close",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
            }, "✕"))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
          return (_openBlock(), _createElementBlock("div", {
            key: tab.key,
            class: _normalizeClass(["mstab", { active: _ctx.activeTab === tab.key }]),
            onClick: ($event: any) => (_ctx.activeTab = tab.key)
          }, [
            (tab.icon)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(tab.icon), 1))
              : _createCommentVNode("", true),
            _createTextVNode(_toDisplayString(tab.label) + " ", 1),
            _createElementVNode("span", {
              class: _normalizeClass(["cnt", { 'cnt-red': tab.key === 'alerts' }])
            }, _toDisplayString(_ctx.tabCount(tab.key)), 3)
          ], 10, _hoisted_10))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_12, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleReadFilters, (f) => {
          return (_openBlock(), _createElementBlock("button", {
            key: f.key,
            class: _normalizeClass(["rf-btn", { active: _ctx.readFilter === f.key }]),
            "data-testid": `omp-read-filter-${f.key}`,
            onClick: ($event: any) => (_ctx.readFilter = f.key)
          }, [
            _createTextVNode(_toDisplayString(f.label) + " ", 1),
            (f.key === 'unread' && _ctx.unreadCount > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.unreadCount), 1))
              : _createCommentVNode("", true)
          ], 10, _hoisted_13))
        }), 128)),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _withDirectives(_createElementVNode("select", {
              class: "rf-sort-select",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.sortBy) = $event))
            }, _hoisted_20, 512), [
              [_vModelSelect, _ctx.sortBy]
            ])
          ]),
          _createElementVNode("button", {
            class: "rf-icon-btn",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.toggleSortDirection && _ctx.toggleSortDirection(...args))),
            title: `Ordre (${_ctx.sortDirection === 'desc' ? 'descendant' : 'ascendant'})`
          }, [
            _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.sortDirection === "desc" ? "arrow_downward" : "arrow_upward"), 1)
          ], 8, _hoisted_21),
          _createElementVNode("button", {
            class: "rf-icon-btn danger",
            disabled: _ctx.deletingAll,
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.deleteAllFilteredMessages && _ctx.deleteAllFilteredMessages(...args))),
            title: "Supprimer tous les messages et alertes affichés"
          }, _hoisted_25, 8, _hoisted_23)
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.searchInput) = $event)),
          placeholder: "Rechercher dans les messages..."
        }, null, 512), [
          [_vModelText, _ctx.searchInput]
        ])
      ]),
      _createElementVNode("div", _hoisted_27, [
        (_ctx.filteredMessages.length > 0)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.filteredMessages, (msg, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                key: msg.resourceUid || idx,
                class: _normalizeClass(["mc", [_ctx.msgCardBorderClass(msg), { 'mc-unread': _ctx.threadHasUnread(msg), 'mc-deleted': _ctx.isDeletedItem(msg), 'mc-selected': (_ctx.selectedMessage && _ctx.selectedMessage.resourceUid === msg.resourceUid) || (_ctx.selectedEmail && _ctx.selectedEmail.resourceUid === msg.resourceUid) }]]),
                "data-testid": "omp-message-row",
                onClick: ($event: any) => (_ctx.openDetail(msg))
              }, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["mc-avatar", _ctx.avatarColorClass(msg)])
                  }, _toDisplayString(_ctx.senderInitials(msg)), 3),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _createTextVNode(_toDisplayString(_ctx.subjectText(msg)) + " ", 1),
                      (!_ctx.orderId)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(msg.metadata.find((m) => m.key === 'Entity_Reference')?.value?.split(','), (ref) => {
                            return (_openBlock(), _createElementBlock("span", {
                              class: _normalizeClass(["ms-subtitle", { 'ms-subtitle-link': _ctx.orderId }]),
                              key: ref,
                              onClick: _withModifiers(($event: any) => (_ctx.openOrderTab(ref)), ["stop"]),
                              title: "Ouvrir le dossier dans un nouvel onglet"
                            }, _toDisplayString(ref) + ", ", 11, _hoisted_32))
                          }), 128))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("span", null, "DE : " + _toDisplayString(msg.sender), 1),
                      (_ctx.recipientLabel(msg))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_34, "| À : " + _toDisplayString(_ctx.recipientLabel(msg)), 1))
                        : (_ctx.channelText(msg))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_35, "→ " + _toDisplayString(_ctx.channelText(msg)), 1))
                          : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    (!msg._isEmail && _ctx.isThreadRoot(msg) && _ctx.getReplyCount(msg) > 0)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "mc-reply-badge",
                          onClick: _withModifiers(($event: any) => (_ctx.openDetail(msg)), ["stop"]),
                          title: "Voir la conversation"
                        }, " 💬 " + _toDisplayString(_ctx.getReplyCount(msg)), 9, _hoisted_37))
                      : _createCommentVNode("", true),
                    (msg._isAlert && !_ctx.isDeletedItem(msg))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "mc-delete-btn",
                          "data-testid": "omp-message-delete",
                          onClick: ($event: any) => (_ctx.deleteMessage(msg, $event)),
                          title: "Supprimer"
                        }, " 🗑️ ", 8, _hoisted_38))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.formatDate(msg.communicationDate)), 1)
                ]),
                (!msg._isEmail)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(_ctx.bodyExcerpt(msg)), 1))
                  : _createCommentVNode("", true),
                (_ctx.isDeletedItem(msg))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                      _createTextVNode(" Supprimé"),
                      (_ctx.deletedByOf(msg))
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(" par : " + _toDisplayString(_ctx.deletedByOf(msg)), 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      (_ctx.deletedAtOf(msg))
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(" le " + _toDisplayString(_ctx.formatDate(_ctx.deletedAtOf(msg), true)), 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showMessageOrderKpiStrip(msg))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messageOrderKpiPills(msg), (pill) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: pill.key,
                          class: "mc-kpi-pill",
                          title: `${pill.label} : ${pill.value}`
                        }, [
                          _createElementVNode("span", _hoisted_44, _toDisplayString(pill.label), 1),
                          _createElementVNode("span", _hoisted_45, _toDisplayString(pill.value), 1)
                        ], 8, _hoisted_43))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_46, [
                  (_ctx.isDeletedItem(msg))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_47, "Supprimé"))
                    : _createCommentVNode("", true),
                  (!msg._isAlert)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        class: _normalizeClass(["tag", _ctx.typeTagClass(msg)])
                      }, _toDisplayString(_ctx.typeLabel(msg)), 3))
                    : _createCommentVNode("", true),
                  (msg.status && !msg._isAlert)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 2,
                        class: _normalizeClass(["tag", _ctx.statusTagClass(msg)])
                      }, _toDisplayString(_ctx.statusLabel(msg)), 3))
                    : _createCommentVNode("", true),
                  (_ctx.alertBadgeLabels(msg).length > 0)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.alertBadgeLabels(msg), (alert) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: alert,
                          class: "tag tg-alert"
                        }, _toDisplayString(alert), 1))
                      }), 128))
                    : _createCommentVNode("", true),
                  (_ctx.attachmentCount(msg) > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_48, " 📎 " + _toDisplayString(_ctx.attachmentCount(msg)), 1))
                    : _createCommentVNode("", true)
                ])
              ], 10, _hoisted_28))
            }), 128))
          : (_openBlock(), _createElementBlock("div", _hoisted_49, "Aucun message pour ce dossier"))
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["eflo-detail-drawer", { open: !!_ctx.selectedMessage }]),
      "data-testid": "omp-detail-drawer"
    }, [
      (_ctx.selectedMessage)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.msgIcon(_ctx.selectedMessage)), 1),
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.subjectText(_ctx.selectedMessage)), 1),
                _createElementVNode("span", _hoisted_54, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["tag", _ctx.typeTagClass(_ctx.selectedMessage)])
                  }, _toDisplayString(_ctx.typeLabel(_ctx.selectedMessage)), 3),
                  (_ctx.selectedMessage.status)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass(["tag", _ctx.statusTagClass(_ctx.selectedMessage)])
                      }, _toDisplayString(_ctx.statusLabel(_ctx.selectedMessage)), 3))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("button", {
                class: "ms-close",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.closeDetail && _ctx.closeDetail(...args)))
              }, "✕")
            ]),
            _createElementVNode("div", _hoisted_55, [
              (_ctx.loadingThread)
                ? (_openBlock(), _createElementBlock("div", _hoisted_56, _hoisted_59))
                : (_ctx.messageThread(_ctx.selectedMessage).length > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.messageThread(_ctx.selectedMessage), (msg, idx) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: msg.resourceUid || idx,
                        class: _normalizeClass(["dd-bubble-row", { 'bubble-row-me': _ctx.isCurrentUser(msg), 'bubble-row-them': !_ctx.isCurrentUser(msg) }])
                      }, [
                        (_ctx.showDateSeparator(_ctx.messageThread(_ctx.selectedMessage), idx))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.formatDateSep(msg.communicationDate)), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (!_ctx.isCurrentUser(msg))
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: _normalizeClass(["dd-bubble-avatar", _ctx.bubbleAvatarClass(msg)])
                            }, _toDisplayString(_ctx.senderInitials(msg)), 3))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_61, [
                          (!_ctx.isCurrentUser(msg))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                _createElementVNode("span", _hoisted_63, _toDisplayString(msg.sender), 1),
                                (msg._threadType === 'reply')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_64, "↩ Réponse"))
                                  : _createCommentVNode("", true),
                                (msg._threadType === 'transfer')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_65, "↪ Transfert"))
                                  : _createCommentVNode("", true)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_66, [
                                (msg._threadType === 'reply')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_67, "↩ Réponse"))
                                  : _createCommentVNode("", true),
                                (msg._threadType === 'transfer')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_68, "↪ Transfert"))
                                  : _createCommentVNode("", true),
                                _hoisted_69
                              ])),
                          (msg._refSubject)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                                _hoisted_71,
                                _createElementVNode("div", null, [
                                  _createElementVNode("div", _hoisted_72, _toDisplayString(_ctx.threadRefLabel(msg)), 1),
                                  _createElementVNode("div", _hoisted_73, _toDisplayString(msg._refSubject), 1)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", {
                            class: _normalizeClass(["dd-bubble", [_ctx.bubbleClass(msg), { 'bubble-alert': _ctx.isAlert(msg) }]])
                          }, [
                            _createElementVNode("div", _hoisted_74, _toDisplayString(msg.body || msg.content), 1),
                            (msg.attachments && msg.attachments.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(msg.attachments, (doc, di) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: doc.resourceUid || di,
                                      class: "dd-bubble-doc"
                                    }, " 📎 " + _toDisplayString(doc.name || doc.resourceUid), 1))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ], 2),
                          _createElementVNode("div", {
                            class: _normalizeClass(["dd-bubble-time", { 'time-right': _ctx.isCurrentUser(msg) }])
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.formatDate(msg.communicationDate, false)) + " ", 1),
                            (_ctx.isCurrentUser(msg))
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  class: _normalizeClass(["dd-read-tick", { 'tick-read': _ctx.isRead(msg) }])
                                }, _toDisplayString(_ctx.isRead(msg) ? '✓✓' : '✓'), 3))
                              : _createCommentVNode("", true)
                          ], 2)
                        ])
                      ], 2))
                    }), 128))
                  : (_openBlock(), _createElementBlock("div", _hoisted_76, _hoisted_79))
            ], 512),
            _createElementVNode("div", _hoisted_80, [
              (_ctx.selectedMessage.type?.resourceUid !== _ctx.MESSAGE_TYPE.MEMO && !_ctx.isTreated(_ctx.selectedMessage))
                ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                    _createElementVNode("button", {
                      class: "dd-action-btn primary",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.startReply(_ctx.selectedMessage)))
                    }, "↩ Répondre")
                  ]))
                : _createCommentVNode("", true),
              (_ctx.selectedMessage.type?.resourceUid !== _ctx.MESSAGE_TYPE.MEMO && !_ctx.isTreated(_ctx.selectedMessage))
                ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                    _createElementVNode("button", {
                      class: "dd-action-btn",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.startTransfer(_ctx.selectedMessage)))
                    }, "↪ Transférer"),
                    (_ctx.canMarkStatus(_ctx.selectedMessage) && _ctx.canMarkRead(_ctx.selectedMessage))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "dd-action-btn",
                          disabled: _ctx.markingRead,
                          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.markAsRead(_ctx.selectedMessage)))
                        }, " 👁 Marquer Lu ", 8, _hoisted_83))
                      : _createCommentVNode("", true),
                    (_ctx.canMarkStatus(_ctx.selectedMessage))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "dd-action-btn",
                          disabled: _ctx.markingTreated,
                          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.markAsTreated(_ctx.selectedMessage)))
                        }, " ✅ Traité ", 8, _hoisted_84))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 64))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["eflo-overlay", { open: !!_ctx.selectedEmail }]),
      onClick: _cache[14] || (_cache[14] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeEmail && _ctx.closeEmail(...args)), ["self"]))
    }, [
      (_ctx.selectedEmail)
        ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
            _createElementVNode("div", _hoisted_86, [
              _hoisted_87,
              _createElementVNode("div", _hoisted_88, [
                _createElementVNode("span", _hoisted_89, _toDisplayString(_ctx.subjectText(_ctx.selectedEmail)), 1),
                (_ctx.selectedEmail._reference)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_90, _toDisplayString(_ctx.selectedEmail._externalReference || _ctx.selectedEmail._reference), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("button", {
                class: "ms-close",
                onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.closeEmail && _ctx.closeEmail(...args)))
              }, "✕")
            ]),
            _createElementVNode("div", _hoisted_91, [
              _createElementVNode("div", _hoisted_92, [
                _hoisted_93,
                _createElementVNode("span", _hoisted_94, _toDisplayString(_ctx.selectedEmail.sender || "—"), 1)
              ]),
              _createElementVNode("div", _hoisted_95, [
                _hoisted_96,
                _createElementVNode("span", _hoisted_97, _toDisplayString(_ctx.selectedEmail.recipient ||
                        "—"), 1)
              ]),
              (_ctx.selectedEmail.copyRecipient)
                ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                    _hoisted_99,
                    _createElementVNode("span", _hoisted_100, _toDisplayString(_ctx.selectedEmail.copyRecipient), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_101, [
                _hoisted_102,
                _createElementVNode("span", _hoisted_103, _toDisplayString(_ctx.formatDate(_ctx.selectedEmail.communicationDate, true)), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_104, [
              (_ctx.emailIsHtml(_ctx.selectedEmail.body))
                ? (_openBlock(), _createElementBlock("iframe", {
                    key: 0,
                    class: "em-iframe",
                    sandbox: "",
                    title: "Contenu de l'email",
                    srcdoc: _ctx.selectedEmail.body
                  }, null, 8, _hoisted_105))
                : (_openBlock(), _createElementBlock("pre", _hoisted_106, _toDisplayString(_ctx.selectedEmail.body), 1))
            ])
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["eflo-overlay", { open: _ctx.showCompose }]),
      onClick: _cache[37] || (_cache[37] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeCompose && _ctx.closeCompose(...args)), ["self"]))
    }, [
      _createElementVNode("div", _hoisted_107, [
        _createElementVNode("div", _hoisted_108, [
          _createElementVNode("div", {
            class: "cm-icon",
            style: _normalizeStyle(_ctx.composeIconStyle)
          }, _toDisplayString(_ctx.composeIconEmoji), 5),
          _createElementVNode("span", _hoisted_109, _toDisplayString(_ctx.composeTitle), 1),
          _createElementVNode("button", {
            class: "cm-close",
            onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.closeCompose && _ctx.closeCompose(...args)))
          }, "✕")
        ]),
        _createElementVNode("div", _hoisted_110, [
          _createElementVNode("div", _hoisted_111, [
            _createElementVNode("div", _hoisted_112, [
              _createElementVNode("div", _hoisted_113, [
                _hoisted_114,
                _createTextVNode(" " + _toDisplayString(_ctx.isSmsMode ? "Type de message" : "Sujet & Référence"), 1)
              ]),
              _createElementVNode("div", _hoisted_115, [
                _createElementVNode("div", _hoisted_116, [
                  _createElementVNode("div", _hoisted_117, [
                    _hoisted_118,
                    _createElementVNode("div", _hoisted_119, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleMsgTypes, (t) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: t.key,
                          class: _normalizeClass(["tt-opt", { active: _ctx.compose.msgType === t.key }]),
                          onClick: ($event: any) => (_ctx.selectMessageType(t.key))
                        }, _toDisplayString(t.icon) + " " + _toDisplayString(t.label), 11, _hoisted_120))
                      }), 128))
                    ])
                  ])
                ]),
                (_ctx.compose.msgType === _ctx.MESSAGE_TYPE.ALERT && !_ctx.isSmsMode)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_121, [
                      _hoisted_122,
                      _createElementVNode("div", _hoisted_123, [
                        _withDirectives(_createElementVNode("select", {
                          class: "fselect",
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.selectedAlertReason) = $event))
                        }, [
                          _hoisted_124,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alertTypes, (al) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: al.key,
                              value: al.key
                            }, _toDisplayString(al.label), 9, _hoisted_125))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, _ctx.selectedAlertReason]
                        ]),
                        (_ctx.selectedAlertReason)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "fselect-clear",
                              onClick: _cache[17] || (_cache[17] = _withModifiers(($event: any) => (_ctx.selectedAlertReason = ''), ["stop"]))
                            }, "✕"))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.isSmsMode)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_126, [
                      _hoisted_127,
                      _createElementVNode("div", _hoisted_128, [
                        _withDirectives(_createElementVNode("select", {
                          class: "fselect",
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.compose.subject) = $event))
                        }, [
                          _hoisted_129,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subjectsList, (s) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: s.value || s,
                              value: s.value || s
                            }, _toDisplayString(s.label || s), 9, _hoisted_130))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, _ctx.compose.subject]
                        ]),
                        (_ctx.compose.subject)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "fselect-clear",
                              onClick: _cache[19] || (_cache[19] = _withModifiers(($event: any) => (_ctx.compose.subject = ''), ["stop"]))
                            }, "✕"))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.compose.msgType !== _ctx.MESSAGE_TYPE.MEMO && !_ctx.isSmsMode)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_131, [
                      _hoisted_132,
                      _createElementVNode("div", _hoisted_133, [
                        _withDirectives(_createElementVNode("input", {
                          class: "finput",
                          type: "text",
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.refSearch) = $event)),
                          placeholder: "Rechercher Offre, Tiers, Commande...",
                          onInput: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.onRefSearch && _ctx.onRefSearch(...args))),
                          onFocus: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.onRefInputFocus && _ctx.onRefInputFocus(...args))),
                          onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.onRefInputFocus && _ctx.onRefInputFocus(...args))),
                          autocomplete: "off",
                          autocorrect: "off",
                          autocapitalize: "off",
                          spellcheck: "false",
                          "data-form-type": "other",
                          "data-lpignore": "true"
                        }, null, 544), [
                          [_vModelText, _ctx.refSearch]
                        ]),
                        (_ctx.refDropOpen && (_ctx.refFilteredOptions.length > 0 || _ctx.refLoading))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_134, [
                              (_ctx.refLoading)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_135, "⏳ Recherche..."))
                                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.refFilteredOptions, (opt) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: _ctx.refLabel(opt) + _ctx.refContext(opt),
                                      class: "ref-opt",
                                      onMousedown: _withModifiers(($event: any) => (_ctx.selectRef(opt)), ["prevent"])
                                    }, [
                                      _createElementVNode("span", {
                                        class: _normalizeClass(["ref-badge", _ctx.refBadgeClass(opt)])
                                      }, _toDisplayString(_ctx.refContext(opt)), 3),
                                      _createElementVNode("span", _hoisted_137, _toDisplayString(_ctx.refLabel(opt)), 1)
                                    ], 40, _hoisted_136))
                                  }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.refDropOpen && !_ctx.refFilteredOptions.length && _ctx.refSearch.length >= 2 && !_ctx.refLoading)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_138, _hoisted_140))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.compose.selectedRefs.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_141, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.compose.selectedRefs, (ref, ri) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: ri,
                                class: "ref-chip"
                              }, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["ref-badge", _ctx.refBadgeClass(ref)])
                                }, _toDisplayString(_ctx.refContext(ref)), 3),
                                _createElementVNode("span", null, _toDisplayString(_ctx.refLabel(ref)), 1),
                                _createElementVNode("button", {
                                  class: "ref-chip-remove",
                                  onClick: ($event: any) => (_ctx.removeRef(ri))
                                }, "✕", 8, _hoisted_142)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_ctx.compose.msgType !== _ctx.MESSAGE_TYPE.MEMO)
              ? (_openBlock(), _createElementBlock("div", _hoisted_143, [
                  _hoisted_144,
                  _createElementVNode("div", _hoisted_145, [
                    _createElementVNode("div", _hoisted_146, [
                      _hoisted_147,
                      (!_ctx.isSmsMode && _ctx.filteredIntervenantBundles.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_148, [
                            _hoisted_149,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredIntervenantBundles, (b) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: _ctx.recipientSuggestionKey(b),
                                class: "recip-intervenant-card"
                              }, [
                                _createElementVNode("div", _hoisted_150, [
                                  _createElementVNode("span", _hoisted_151, _toDisplayString(_ctx.orderPartyRoleLabel(b.orderPartyRole)), 1),
                                  _createElementVNode("div", _hoisted_152, [
                                    _createElementVNode("span", _hoisted_153, _toDisplayString(b.name || b.emailOption?.email), 1),
                                    (b.emailOption?.email)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_154, _toDisplayString(b.emailOption.email), 1))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_155, [
                                  (b.userOption)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        type: "button",
                                        class: "recip-cta recip-cta-message",
                                        onClick: ($event: any) => (_ctx.selectIntervenantChannel(b, 'user'))
                                      }, "Message", 8, _hoisted_156))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "recip-cta recip-cta-mail",
                                    onClick: ($event: any) => (_ctx.selectIntervenantChannel(b, 'email'))
                                  }, "Mail", 8, _hoisted_157)
                                ])
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (!_ctx.isSmsMode)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_158, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["recip-filter-tab", { active: _ctx.recipientFilter === 'All' }]),
                              onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.recipientFilter = 'All'))
                            }, "Tous", 2),
                            _createElementVNode("span", {
                              class: _normalizeClass(["recip-filter-tab", { active: _ctx.recipientFilter === 'User' }]),
                              onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.recipientFilter = 'User'))
                            }, "Utilisateurs", 2),
                            _createElementVNode("span", {
                              class: _normalizeClass(["recip-filter-tab", { active: _ctx.recipientFilter === 'Group' }]),
                              onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.recipientFilter = 'Group'))
                            }, "Groupes", 2)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_159, [
                        _withDirectives(_createElementVNode("input", {
                          class: "finput",
                          type: "text",
                          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.recipientSearch) = $event)),
                          placeholder: _ctx.isSmsMode ? 'Rechercher un utilisateur ou saisir un numéro (Entrée pour ajouter)...' : 'Rechercher un utilisateur ou saisir un email (Entrée pour ajouter)...',
                          onFocus: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.onRecipInputFocus && _ctx.onRecipInputFocus(...args))),
                          onClick: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.onRecipInputFocus && _ctx.onRecipInputFocus(...args))),
                          onKeydown: _cache[30] || (_cache[30] = _withKeys(_withModifiers(($event: any) => (_ctx.addRecipientFromSearch()), ["prevent"]), ["enter"])),
                          autocomplete: "off",
                          autocorrect: "off",
                          autocapitalize: "off",
                          spellcheck: "false",
                          "data-form-type": "other",
                          "data-lpignore": "true",
                          name: "recipient-search-no-autofill"
                        }, null, 40, _hoisted_160), [
                          [_vModelText, _ctx.recipientSearch]
                        ]),
                        (_ctx.recipDropOpen && _ctx.filteredRecipientOptions.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_161, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredRecipientOptions, (r) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: _ctx.recipientSuggestionKey(r),
                                  class: "recip-opt"
                                }, [
                                  _createElementVNode("div", {
                                    class: "recip-opt-simple",
                                    onMousedown: _withModifiers(($event: any) => (_ctx.selectRecipient(r)), ["prevent"])
                                  }, [
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["recip-badge", _ctx.getRecipientTypeClass(r)])
                                    }, _toDisplayString(_ctx.getRecipientTypeLabel(r)), 3),
                                    _createElementVNode("div", _hoisted_163, [
                                      _createElementVNode("span", _hoisted_164, _toDisplayString(_ctx.getRecipientDisplayName(r)), 1),
                                      (!_ctx.isSmsMode && r.isOrderPartyLinkedUser && r.orderPartyRole)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_165, _toDisplayString(_ctx.orderPartyRoleLabel(r.orderPartyRole)) + " · " + _toDisplayString(r.email || ""), 1))
                                        : _createCommentVNode("", true),
                                      (!_ctx.isSmsMode && r.isFromOrderParty && r.email && r.name)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_166, _toDisplayString(r.email), 1))
                                        : _createCommentVNode("", true),
                                      (_ctx.isSmsMode)
                                        ? (_openBlock(), _createElementBlock("span", {
                                            key: 2,
                                            class: _normalizeClass(["recip-sub", { 'recip-sub-missing': !_ctx.getPrimaryRecipientPhone(r) }])
                                          }, _toDisplayString(_ctx.recipientPhoneHint(r)), 3))
                                        : _createCommentVNode("", true)
                                    ])
                                  ], 40, _hoisted_162)
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.recipDropOpen && _ctx.filteredRecipientOptions.length === 0 && _ctx.recipientSearch.length >= 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_167, _hoisted_169))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.compose.selectedRecipients.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_170, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.compose.selectedRecipients, (r, ri) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: ri,
                                class: "recip-chip"
                              }, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["recip-badge", _ctx.getRecipientTypeClass(r)])
                                }, _toDisplayString(_ctx.getRecipientTypeLabel(r)), 3),
                                _createElementVNode("div", _hoisted_171, [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.getRecipientDisplayName(r)), 1),
                                  (!_ctx.isSmsMode && r.isOrderPartyLinkedUser && r.orderPartyRole)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_172, _toDisplayString(_ctx.orderPartyRoleLabel(r.orderPartyRole)) + " · " + _toDisplayString(r.email || ""), 1))
                                    : _createCommentVNode("", true),
                                  (!_ctx.isSmsMode && r.isFromOrderParty && r.email && r.name)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_173, _toDisplayString(r.email), 1))
                                    : _createCommentVNode("", true),
                                  (_ctx.isSmsMode)
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 2,
                                        class: _normalizeClass(["recip-sub", { 'recip-sub-missing': !_ctx.getPrimaryRecipientPhone(r) && !r.isPhone }])
                                      }, _toDisplayString(_ctx.recipientPhoneHint(r)), 3))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("button", {
                                  class: "recip-chip-remove",
                                  onClick: ($event: any) => (_ctx.removeRecipient(ri))
                                }, "✕", 8, _hoisted_174)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (!_ctx.hasRecipientDirectory)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_175, _toDisplayString(_ctx.isSmsMode ? "Aucun destinataire disponible. Saisissez un numéro manuellement." :
                                        "Aucun destinataire disponible"), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_176, [
            _createElementVNode("div", _hoisted_177, [
              _hoisted_178,
              _createElementVNode("div", _hoisted_179, [
                (_ctx.compose.replyTo || _ctx.compose.transferOf)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_180, [
                      (_ctx.compose.replyTo)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_181, [
                            _createTextVNode(" ↩ Réponse à : "),
                            _createElementVNode("strong", null, _toDisplayString(_ctx.subjectText(_ctx.compose.replyTo)), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.compose.transferOf)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_182, [
                            _createTextVNode(" ↪ Transfert de : "),
                            _createElementVNode("strong", null, _toDisplayString(_ctx.subjectText(_ctx.compose.transferOf)), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", {
                        class: "context-clear",
                        onClick: _cache[31] || (_cache[31] = ($event: any) => {_ctx.compose.replyTo = null; _ctx.compose.transferOf = null})
                      }, "✕")
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_183, [
                  _hoisted_184,
                  _withDirectives(_createElementVNode("textarea", {
                    class: "ftextarea",
                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.compose.body) = $event)),
                    placeholder: "Saisir le contenu du message...",
                    rows: 6
                  }, null, 512), [
                    [_vModelText, _ctx.compose.body]
                  ])
                ])
              ])
            ]),
            (!_ctx.isSmsMode)
              ? (_openBlock(), _createElementBlock("div", _hoisted_185, [
                  _hoisted_186,
                  _createElementVNode("div", _hoisted_187, [
                    _hoisted_188,
                    (_ctx.orderReference && _ctx.flattenedDocuments && _ctx.flattenedDocuments.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_189, [
                          _hoisted_190,
                          _createElementVNode("div", _hoisted_191, [
                            _withDirectives(_createElementVNode("input", {
                              class: "finput",
                              type: "text",
                              "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.docSearch) = $event)),
                              placeholder: "Rechercher un document..."
                            }, null, 512), [
                              [_vModelText, _ctx.docSearch]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_192, [
                            (_ctx.filteredFlattenedDocuments.length > 0)
                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.filteredFlattenedDocuments, (doc) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: doc.resourceUid,
                                    class: _normalizeClass(["doc-item", { on: _ctx.compose.selectedDocs.includes(doc.resourceUid) }]),
                                    onClick: ($event: any) => (_ctx.toggleDocItem(doc.resourceUid))
                                  }, [
                                    _hoisted_194,
                                    _createElementVNode("div", _hoisted_195, [
                                      _createElementVNode("span", _hoisted_196, _toDisplayString(doc.displayName), 1),
                                      _createElementVNode("span", _hoisted_197, _toDisplayString(doc.processLabel || 'Document'), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_198, _toDisplayString(_ctx.compose.selectedDocs.includes(doc.resourceUid) ? '✓' : ''), 1)
                                  ], 10, _hoisted_193))
                                }), 128))
                              : (_openBlock(), _createElementBlock("div", _hoisted_199, "Aucun document trouvé"))
                          ]),
                          (_ctx.compose.selectedDocs.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_200, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.compose.selectedDocs, (uid) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: uid,
                                    class: "ref-chip"
                                  }, [
                                    _hoisted_201,
                                    _createElementVNode("span", null, _toDisplayString(_ctx.flattenedDocuments.find(d => d.resourceUid === uid)?.displayName || uid), 1),
                                    _createElementVNode("button", {
                                      class: "ref-chip-remove",
                                      onClick: ($event: any) => (_ctx.removeDocument(uid))
                                    }, "✕", 8, _hoisted_202)
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_203, [
                      _hoisted_204,
                      _createElementVNode("input", {
                        class: "finput",
                        type: "file",
                        style: {"padding":"5px 11px","cursor":"pointer"},
                        onChange: _cache[34] || (_cache[34] = 
//@ts-ignore
(...args) => (_ctx.onFileChange && _ctx.onFileChange(...args))),
                        accept: ".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,.txt"
                      }, null, 32),
                      (_ctx.compose.attachedFile)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_205, " 📎 " + _toDisplayString(_ctx.compose.attachedFile.name), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.sendingMessage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_206, _hoisted_208))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_209, [
          _createElementVNode("div", _hoisted_210, [
            (_ctx.composeError)
              ? (_openBlock(), _createElementBlock("span", _hoisted_211, "⚠ " + _toDisplayString(_ctx.composeError), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_212, [
            _createElementVNode("button", {
              class: "btn-cancel",
              onClick: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_ctx.closeCompose && _ctx.closeCompose(...args)))
            }, "Annuler"),
            _createElementVNode("button", {
              class: _normalizeClass(["btn-send", { 'alert-mode': _ctx.compose.alertType.length > 0, 'important-mode': _ctx.compose.important }]),
              disabled: _ctx.sendingMessage || !_ctx.canSend,
              onClick: _cache[36] || (_cache[36] = 
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args)))
            }, _toDisplayString(_ctx.sendBtnLabel), 11, _hoisted_213)
          ])
        ])
      ])
    ], 2)
  ], 64))
}